import {
  type Variant,
  PaymentOption,
  type PurchaseOption,
  type BidPurchaseOption,
} from '../../../../types/CoreShoppingExperience';

const findCashPurchaseOption = (variant: Variant): BidPurchaseOption | PurchaseOption => {
  const purchaseOption = variant.purchaseOptions.find((x) => x.paymentOption === PaymentOption.CASH);

  if (!purchaseOption) {
    throw new Error('Variant has no CASH purchase options!');
  }

  return purchaseOption;
};

export default findCashPurchaseOption;
